<template>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12 sm8 md4>
                <v-card class="elevation-12">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>Forgot Password</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-form @submit.prevent="onForgot()">
                            <v-text-field
                                    placeholder="Your registered AR email address"
                                    v-validate="'required|email'"
                                    prepend-icon="person"
                                    v-model="email"
                                    :error-messages="errors.collect('email')"
                                    label="E-mail"
                                    data-vv-name="email"
                                    required
                            >
                            </v-text-field>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn :to="{ name: 'home'}" outline color="primary">Home</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn :disabled="(isSubmitting || !isFormValid)" color="primary" @click="onForgot()">Forgot</v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>

import { mapActions } from 'vuex'

export default {
  name: 'Forgot',
  data () {
    return {
      isSubmitting: false,
      email: process.env.VUE_APP_LOGIN_EMAIL
    }
  },
  computed: {
    isFormValid () {
      return Object.keys(this.fields).every(key => this.fields[key].validated) && Object.keys(this.fields).every(key => this.fields[key].valid)
    }
  },
  methods: {
    ...mapActions(
      'auth', {
        forgot: 'forgot'
      }
    ),
    onForgot () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.internalForgot()
        } else {
          for (let m of this.errors.collect('email')) {
            this.$snackbar.show(m)
          }
        }
      })
    },
    internalForgot () {
      this.isSubmitting = true
      this.forgot(this.email).then((data) => {
        this.$nextTick()
          .then(() => {
            this.email = null
            this.$validator.reset()
            this.errors.clear()
            this.$snackbar.show(data.message)
            this.$router.push({ name: 'login' })
          })
      }).catch((error) => {
        this.$snackbar.show(error.response.data.data.message)
      }).then(() => {
        this.isSubmitting = false
      })
    }
  }
}
</script>

<style scoped>

</style>
